import Constants from "../Constants";

export const getSelectedAssets = (contentType, selectedTreeData, sourceLanguage, isClone) => {
    const selectedAssets = [];
    for(var index in selectedTreeData) {
        var item = selectedTreeData[index];
        // first add in one for the source language
        if(sourceLanguage) {
            selectedAssets.push({
                langCode: sourceLanguage.code,
                language:sourceLanguage.language,
                externalId: item.externalId || item.id,
                contentType: contentType,
                assetType: getAssetType(item, contentType,isClone),
                includeDependencies: getIncludeDependencies(contentType),
                url: getUrl(item, contentType),
                name: getName(item, contentType),
                parentAssetId: item.parentAssetId,
                parentAssetUrl: item.parentAssetUrl,
                parentAssetType: getParentAssetType(item, contentType),
                projectAsset: item.projectAsset,
                uploadedFileName: item.uploadedFileName
            })          
        }

        // then one per target language
        for(var langIndex in item.targetLanguages) {
            if (contentType === Constants.ELOQUA && getAssetType(item, contentType,isClone) === Constants.IMAGE) {
                continue;
            }
            var overrideTemplate = null;
            var targetLang = item.targetLanguages[langIndex];

            // var templateKey = targetLang.langCode + "-" + item.type + "-" + item.id;

            // if (this.templateOverrides && this.templateOverrides[templateKey])  {
            // 	overrideTemplate = this.templateOverrides[templateKey];
            // }

            //if((!item.targetLanguages[langIndex].translated) && (!item.targetLanguages[langIndex].in_translation)) {
                
            selectedAssets.push({
                langCode: targetLang.code,
                language:targetLang.language ? targetLang.language : targetLang.name,
                externalId: item.externalId || item.id,
                contentType: contentType,
                assetType: getAssetType(item, contentType,isClone),
                name: getName(item, contentType),
                includeDependencies: getIncludeDependencies(contentType),
                url: getUrl(item, contentType),
                overrideTemplate : overrideTemplate,
                parentAssetId: item.parentAssetId,
                parentAssetUrl: item.parentAssetUrl,
                parentAssetType: getParentAssetType(item, contentType),
                ubHubId: targetLang.ubHubId,
                ubHubName: targetLang.ubHubName,
                ubStreamId: targetLang.ubStreamId,
                ubStreamName: targetLang.ubStreamName
            })      
                
            //}
            
        }
    }

    // for(var index in this.selectedImageAssets) {
    // 	var item = this.selectedImageAssets[index];
    // 	// only need to add for source language, back-end handles the rest
    // 	if(this.sourceLanguage) {
    // 		selectedAssets.push({language: this.sourceLanguage.toJSON()}, item);
    // 	}
    // }

    return selectedAssets;
}

// const getIncludeDependencies = (selectedAssets, includeDependencies, dependenciesCheckboxPreference) => {
//     // initialize includeDependencies if null using existing assets. default to true
//     let includeDependencies = true;
//     if(includeDependencies === undefined || includeDependencies === null) {
//         if(selectedAssets?.length > 0) {
//             var asset = selectedAssets[0];
//             includeDependencies = (asset.includeDependencies !== null) ? asset.includeDependencies : true;
//         } else if(dependenciesCheckboxPreference) {
//             var checkboxState = dependenciesCheckboxPreference.get("status");
//             includeDependencies = (checkboxState === "true") ? true : false;
//         } else {
//             includeDependencies = true;
//         }
//     }
//     return includeDependencies;
// }

const getIncludeDependencies = (contentType) => {
    if (contentType === Constants.MARKETOREST) {
        return true;
    }else if (contentType === Constants.ELOQUA) {
        return true;
    }
}

const getParentAssetType = (asset, contentType) => {
    let parentAssetType = "";
    if (contentType === Constants.UBERFLIP) {
        parentAssetType = Constants.BLOG;
    } else {
        parentAssetType = asset.parentAssetType
    }
    return parentAssetType?.toUpperCase();
} 

const mktPrgmCompTypes = ["marketing program", "marketing event", "email batch program", "nurture program"];

export const isMarketingProgram = (treeNode) => {
    return treeNode && treeNode.folderType && mktPrgmCompTypes.includes(treeNode.folderType?.toLowerCase());
}

export const getAssetType = (asset, contentType,isClone) => {
    let assetType = "";
    if (contentType === Constants.ELOQUA) {
        if(isClone){
            assetType = asset.assetType;
        }else{
            assetType = asset.type || asset.assetType;
        }
    } else if (contentType === Constants.MARKETOREST) {
        if (isMarketingProgram(asset)) {
            return Constants.MARKETING_PROGRAM_CODE
        }
        assetType = asset.assetType;
    } else if (contentType === Constants.BRIGHTCOVE) {
        assetType = asset.assetType;
    } else if (contentType === Constants.PARDOT) {
        assetType = asset.assetType;
    } else if (contentType === Constants.VIDYARD) {
        assetType = asset.assetType;
    } else if (contentType === Constants.UBERFLIP) {
        assetType = asset.assetType;
    } else if (contentType === Constants.EXACTTARGET) {
        assetType = asset.assetType;
    }

    if (assetType?.toLowerCase() === "form") {
        return Constants.LP_FORM_CODE;
    } else if (assetType?.toLowerCase() === "landingpage") {
        return Constants.LANDING_PAGE_CODE;
    } else if (assetType?.toLowerCase() === "email") {
        return Constants.EMAIL_CODE;
    } else if (assetType === Constants.LANDING_PAGE_TEMPLATE) {
        return Constants.LANDING_PAGE_TEMPLATE_CODE;
    } else if (assetType === Constants.LANDING_PAGE) {
        return Constants.LANDING_PAGE_CODE;
    } else if (assetType === Constants.EMAIL_TEMPLATE) {
        return Constants.EMAIL_TEMPLATE_CODE;
    } else if (assetType === Constants.EMAIL) {
        return Constants.EMAIL_CODE;
    } else if (assetType === Constants.LP_FORM) {
        return Constants.LP_FORM_CODE;
    }  else if (assetType === Constants.NORMAL_FORM) {
        return Constants.LP_FORM_CODE;
    } else if (assetType === Constants.SNIPPET) {
        return Constants.SNIPPET_CODE;
    } else if (assetType === Constants.WS_ZONE) {
        return Constants.WS_CODE;
    } else if (assetType === Constants.SMART_CAMPAIGN) {
        return Constants.CAMPAIGN_CODE;
    } else if (assetType === Constants.MARKETO_PROGRAM_STR) {
        return Constants.MARKETING_PROGRAM_CODE;
    } else if (assetType === Constants.CAPTIONS) {
        return Constants.CAPTIONS_CAPS;
    } else if (assetType === Constants.CAPTIONS_CAMEL) {
        return Constants.CAPTIONS_CAPS;
    } else if (assetType === Constants.VIDEO) {
        return Constants.VIDEO_CAPS;
    } else if (assetType === Constants.BLOG_POST_SMALL) {
        return Constants.BLOG_POST;
    } else if (assetType === Constants.IMAGE) {
        return Constants.IMAGE;
    }
    return assetType;
}

const getUrl = (item, contentType) => {
    if (contentType === Constants.ELOQUA) {
        return item.previewUrl;
    } else if (contentType === Constants.MARKETOREST) {
        return item.url;
    } else if (contentType === Constants.BRIGHTCOVE) {
        return item.assetUrl;
    } else if (contentType === Constants.PARDOT) {
        return item.assetUrl;
    } else if (contentType === Constants.VIDYARD) {
        return item.assetUrl;
    } else if (contentType === Constants.UBERFLIP) {
        return item.assetUrl;
    } else if (contentType === Constants.EXACTTARGET) {
        return item.assetUrl;
    }
}

const getName = (item, contentType) => {
    if (contentType === Constants.ELOQUA) {
        return item.name;
    } else if (contentType === Constants.MARKETOREST) {
        return item.name;
    } else if (contentType === Constants.BRIGHTCOVE) {
        return item.assetName;
    } else if (contentType === Constants.PARDOT) {
        return item.assetName;
    } else if (contentType === Constants.VIDYARD) {
        return item.assetName;
    } else if (contentType === Constants.UBERFLIP) {
        return item.assetName;
    } else if (contentType === Constants.EXACTTARGET) {
        return item.assetName;
    }
}

const getContentType = (contentType) => {
    if (contentType === Constants.ELOQUA) {
        return Constants.ELOQUA
    } else if (contentType === Constants.MARKETOREST) {
        return Constants.MARKETOREST
    }
}

export const getSelectedAssetKeys = (selectedAssets, projectRules, sourceLanguage, contentType, isSegModeEnabled, isClone) => {
    var includeDependencies = true;

    var ruleValuesTargetLanguagesJSON = {};
    var assetTargetLanguages = [];
    projectRules?.map(assetRule => {
      let assetRuleValues = assetRule.ruleValues;
      assetRuleValues?.map(assetRuleValue => {
        if(assetRuleValue.language !== null) {
          ruleValuesTargetLanguagesJSON[assetRuleValue.externalRuleValueId] = assetRuleValue.language;
          if((sourceLanguage !== assetRuleValue?.language)
            && !checkLanguageRepition(assetTargetLanguages, assetRuleValue.language)) {
            assetTargetLanguages.push(assetRuleValue.language);
          }
        }
      })
    })

    var selectedAssetKeys = [];
    
    for (var index in selectedAssets) {
      var item = selectedAssets[index];
      var type = getAssetType(item, getContentType(contentType),isClone);
      if(type === undefined || type?.length == 0) {
        type = item?.assetType;
      }
      if(isSegmentationModeEnabled(isSegModeEnabled, projectRules)) {
        selectedAssetKeys.push({
          name : item.name,
          externalId : item.externalId || item.id,
          assetType : type,
          contentType : getContentType(contentType),
          includeDependencies : includeDependencies,
          sourceLanguage : sourceLanguage,
          targetLanguages : assetTargetLanguages,
          ruleIdLanguageMap : ruleValuesTargetLanguagesJSON
        });
      } else {
        selectedAssetKeys.push({
          name : item.name,
          externalId : item.externalId || item.id,
          assetType : type,
          contentType : getContentType(contentType),
          includeDependencies : includeDependencies
        });
      }
    }
    return selectedAssetKeys;
  }

  export const isSegmentationModeEnabled = (isSegmentationModeEnabled, projectRules) => {
    return isSegmentationModeEnabled && projectRules?.length > 0;
  }

  const checkLanguageRepition = (assetTargetLanguages, language) => {
    let languageExists = false;
    assetTargetLanguages?.map(assetTargetLanguage => {
      if(language === assetTargetLanguage) {
        languageExists = true;
      }
    })
    return languageExists;
  }

